var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowLess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ctrl-down 1",
    clipPath: "url(#clip0_3565_8752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.375 9.28095L6.00005 5.78095L1.62505 9.28095C1.52249 9.36302 1.40476 9.4241 1.2786 9.46067C1.15243 9.49725 1.0203 9.50863 0.88974 9.49414C0.759181 9.47965 0.632754 9.43959 0.517676 9.37625C0.402599 9.3129 0.301125 9.22751 0.219049 9.12495C0.136973 9.02239 0.0759014 8.90466 0.0393218 8.7785C0.00274224 8.65233 -0.0086292 8.5202 0.00585674 8.38964C0.0203427 8.25908 0.0604023 8.13265 0.123748 8.01758C0.187095 7.9025 0.272487 7.80102 0.375049 7.71895L5.37505 3.71895C5.55241 3.57694 5.77284 3.49957 6.00005 3.49957C6.22725 3.49957 6.44769 3.57694 6.62505 3.71895L11.625 7.71895C11.8322 7.88471 11.965 8.12596 11.9942 8.38964C12.0235 8.65332 11.9468 8.91781 11.781 9.12495C11.699 9.22751 11.5975 9.3129 11.4824 9.37625C11.3673 9.43959 11.2409 9.47965 11.1104 9.49414C10.8467 9.5234 10.5822 9.44671 10.375 9.28095Z",
    fill: "#056EE6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3565_8752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLess);
export default __webpack_public_path__ + "static/media/showLess.26f95f00e55cb59e1ed1787e943be1a7.svg";
export { ForwardRef as ReactComponent };